import { useExodus } from '@exodus/headless-react';
import { useCallback } from 'react';
import useOrigin from '../use-origin.js';
const useTrackAssetSwap = () => {
    const exodus = useExodus();
    const [origin] = useOrigin();
    return useCallback((params) => {
        const { success } = params;
        void exodus.analytics.track({
            event: 'ExchangeAssetSwap',
            properties: {
                origin,
                success,
            },
        });
    }, [exodus.analytics, origin]);
};
export default useTrackAssetSwap;
